// src/pages/SalesReturnRecord/SalesReturnRecordThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../apiservice/apis";
import dayjs from "dayjs";
import { salesReturnDeleteApi, salesReturnDeleteCheckApi } from "../../apiservice/sales";
const itemFamily = ["By Item", "By Group", "By Category"];
export const fetchSalesReturnRecord = createAsyncThunk(
  "salesReturnRecord/fetch",
  async ({ selectedFilterType, selectedRecordType, filters }, { rejectWithValue }) => {
    try {
      let url = "/sales/get-sales-return-record";
      if (selectedRecordType === "with item") {
        url = "/sales/get-sales-return-record-with-details";
      }
      if (
        selectedFilterType &&
        ["By Item", "By Tag", "By Group", "By Category"].includes(selectedFilterType)
      ) {
        url = "/sales/get-sales-return-details";
      }

      const payload = {
        selectedFilterType: selectedFilterType || null,
        selectedRecordType: selectedRecordType || null,
        locationId: selectedFilterType === "By Location" ? filters.locationId || null : null,
        customerId: selectedFilterType === "By Customer" ? filters.customerId || null : null,
        employeeId: selectedFilterType === "By Employee" ? filters.employeeId || null : null,
        itemId: selectedFilterType === "By Item" ? filters.itemId || null : null,
        groupId: selectedFilterType === "By Group" ? filters.groupId || null : null,
        categoryId: selectedFilterType === "By Category" ? filters.categoryId || null : null,
        userId: selectedFilterType === "By User" ? filters.userId || null : null,
        serialNumber: selectedFilterType === "By Item Serial" ? filters.serialNumber || "" : "",
        tag_groupnameid: selectedFilterType === "By Tag" ? filters.tag_groupnameid || null : null,
        tagFeildNameid: selectedFilterType === "By Tag" ? filters.tagFeildNameid || null : null,
        fromDate: filters.fromDate || null,
        toDate: filters.toDate || null,
      };


      const res = await postData(url, payload);

      let mapped = [];
      if (selectedRecordType === "with item") {
        // flatten items
        mapped = res.data.flatMap((sale, saleIndex) =>
          (sale.details || []).map((item, idx) => ({
            id: `${sale.sale_id}-${item.item_id}-${idx}`,
            sale_r_id: sale.sale_r_id,
            vch_no: sale.sale_r_voucher_no,
            date: sale.created_date,
            customer: sale.acc_name,
            employee: sale.employee_name,
            createdBy: sale.full_name,
            mode: sale.trans?.map((t) => t.to_acc_name).join(", ") || "",
            item: item.item_name,
            rate: Number(item.item_rate || 0),
            discount: Number(item.item_discount_per || 0),
            vat: Number(item.item_tax_per || 0),
            cgst_amount: sale.cgst_amount,
            sgst_amount: sale.sgst_amount,
            igst_amount: sale.igst_amount,

            qty: Number(item.sale_r_qty || 0),
            total: Number(item.item_total || 0).toFixed(2),
            unitDetails: `Master U. Qty = ${item.sale_r_qty || 0}, Base U. Qty = ${item.sale_r_qty || 0}`,
            // tatmeen_sent_status: row.tatmeen_sent_status,
            // sscc_code: row.sscc_code,
            // tatmeen_message_id: row.tatmeen_message_id,
            // tatmeen_retry_count: row.tatmeen_retry_count,
            // tatmeen_failure_reason: row.tatmeen_failure_reason,
            // tatmeen_sscc_status: row.tatmeen_sscc_status,
            // tatmeen_manual_action_required:
            //   row.tatmeen_manual_action_required,
            // tatmeen_last_retry_at:
            //   row.tatmeen_last_retry_at,
            tatmeen_sent_status: sale.tatmeen_sent_status,
            sscc_code: sale.sscc_code,
            tatmeen_message_id: sale.tatmeen_message_id,
            tatmeen_retry_count: sale.tatmeen_retry_count,
            tatmeen_failure_reason: sale.tatmeen_failure_reason,
            tatmeen_sscc_status: sale.tatmeen_sscc_status,
            tatmeen_manual_action_required: sale.tatmeen_manual_action_required,
            tatmeen_last_retry_at: sale.tatmeen_last_retry_at,

            // ✅ NEW: Unpack tracking fields
            unpack_log_id: sale.unpack_log_id,
            unpack_status: sale.unpack_status,
            unpack_type: sale.unpack_type,
            unpacked_at: sale.unpacked_at,
            unpack_retry_count: sale.unpack_retry_count,
            unpack_last_retry_at: sale.unpack_last_retry_at,
            unpack_next_retry_at: sale.unpack_next_retry_at,
            unpack_last_error: sale.unpack_last_error,
            unpack_failure_reason: sale.unpack_failure_reason,
            unpack_manual_action_required: sale.unpack_manual_action_required,
            unpack_message_id: sale.unpack_message_id,
          }))
        );
      } else if (itemFamily.includes(selectedFilterType)) {
        mapped = res.data.map((row) => ({
          id: row.sale_id,
          sale_r_id: row.sale_r_id,
          vch_no: row.sale_r_voucher_no,
          date: row.created_date,
          customer: row.acc_name,
          createdBy: row.full_name,
          item: row.item_name,
          qty: Number(row.sale_r_qty || 0),
          rate: Number(row.item_return_unit_price || 0),
          discount: Number(row.item_discount_per || 0),
          vat: Number(row.item_tax_per || 0),
          service: Number(row.other_service_cost || 0),
          total: Number(row.item_total || 0).toFixed(2),
          paid: Number(row.paid_total || 0),
          due: Number(row.due_total || 0),
          grpname: row.group_name,
          categoryName: row.category_name,
          tatmeen_sent_status: row.tatmeen_sent_status,
          sscc_code: row.sscc_code,
          tatmeen_message_id: row.tatmeen_message_id,
          tatmeen_retry_count: row.tatmeen_retry_count,
          tatmeen_failure_reason: row.tatmeen_failure_reason,
          tatmeen_sscc_status: row.tatmeen_sscc_status,
          tatmeen_manual_action_required:
            row.tatmeen_manual_action_required,
          tatmeen_last_retry_at:
            row.tatmeen_last_retry_at,
          unpack_log_id: row.unpack_log_id,
          unpack_status: row.unpack_status,
          unpack_type: row.unpack_type,
          unpacked_at: row.unpacked_at,
          unpack_retry_count: row.unpack_retry_count,
          unpack_last_retry_at: row.unpack_last_retry_at,
          unpack_next_retry_at: row.unpack_next_retry_at,
          unpack_last_error: row.unpack_last_error,
          unpack_failure_reason: row.unpack_failure_reason,
          unpack_manual_action_required: row.unpack_manual_action_required,
          unpack_message_id: row.unpack_message_id,
        }));
      } else {
        // summary mode
        mapped = res.data.map((row) => ({
          id: row.sale_id,
          sale_r_id: row.sale_r_id,
          vch_no: row.sale_r_voucher_no,
          date: row.created_date,
          customer: row.acc_name,
          employee: row.employee_name,
          createdBy: row.full_name,
          mode: row.trans?.map((t) => t.to_acc_name).join(", ") || "",
          subtotal: Number(row.sub_total || 0),
          discount: Number(row.total_discount || 0),
          vat: Number(row.total_tax || 0),
          cgst_amount: row.cgst_amount,
          sgst_amount: row.sgst_amount,
          igst_amount: row.igst_amount,

          service: Number(row.other_service_cost || 0),
          total: Number(row.total_amount || 0).toFixed(2),
          paid: Number(row.paid_total || 0),
          due: Number(row.due_total || 0),
          tatmeen_sent_status: row.tatmeen_sent_status,
          sscc_code: row.sscc_code,
          tatmeen_message_id: row.tatmeen_message_id,
          tatmeen_retry_count: row.tatmeen_retry_count,
          tatmeen_failure_reason: row.tatmeen_failure_reason,
          tatmeen_sscc_status: row.tatmeen_sscc_status,
          tatmeen_manual_action_required:
            row.tatmeen_manual_action_required,
          tatmeen_last_retry_at:
            row.tatmeen_last_retry_at,
          unpack_log_id: row.unpack_log_id,
          unpack_status: row.unpack_status,
          unpack_type: row.unpack_type,
          unpacked_at: row.unpacked_at,
          unpack_retry_count: row.unpack_retry_count,
          unpack_last_retry_at: row.unpack_last_retry_at,
          unpack_next_retry_at: row.unpack_next_retry_at,
          unpack_last_error: row.unpack_last_error,
          unpack_failure_reason: row.unpack_failure_reason,
          unpack_manual_action_required: row.unpack_manual_action_required,
          unpack_message_id: row.unpack_message_id,
        }));
      }

      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ❗ Checks if delete is allowed
export const checkSalesReturnDelete = createAsyncThunk(
  "salesReturn/checkDelete",
  async (sale_r_id, { rejectWithValue }) => {
    try {
      const res = await salesReturnDeleteCheckApi({ sale_r_id });
      return res.data; // ✅ returns { message: "yes" | "no" }
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


// ✅ Performs delete
export const deleteSalesReturn = createAsyncThunk(
  "salesReturn/delete",
  async (sale_r_id, { rejectWithValue }) => {
    try {
      const res = await salesReturnDeleteApi({ sale_r_id });
      return { sale_r_id, message: res.data.message }; 
    } catch (err) {
      console.log(err, "err123");

      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const receiveSalesReturnInventory = createAsyncThunk(
  "salesReturn/receiveInventory",
  async (sale_r_id, { rejectWithValue }) => {
    try {
      const res = await postData("/sales/receive", { sale_r_id });

      // ✅ Check both wrapper and body for errors
      if (res?.data?.error || res?.error) {
        return rejectWithValue(
          res?.data?.message || res?.message || "Receive failed"
        );
      }

      return res?.data || res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message ||
        err.response?.data ||
        err.message
      );
    }
  }
);




export const unpackSalesReturn = createAsyncThunk(
  "salesReturn/unpack",
  async (sale_r_id, { rejectWithValue }) => {
    try {
      const res = await postData("/sales/unpack-all", { sale_r_id });

      // ✅ Check both wrapper and body for errors
      if (res?.data?.error || res?.error) {
        return rejectWithValue(
          res?.data?.message || res?.message || "Unpack failed"
        );
      }

      return res?.data || res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message ||
        err.response?.data ||
        err.message
      );
    }
  }
);
